import { fetchCommerceAnalyticsData } from '../api/commerceAnalytics';
import NetworkBinding from '../binding/networkBinding';
import { createNetworkHook } from '../binding/useNetworkBinding';
export const commerceAnalyticsDataBinding = new NetworkBinding(fetchCommerceAnalyticsData);
const useCommerceAnalyticsDataBinding = createNetworkHook(commerceAnalyticsDataBinding);
export default useCommerceAnalyticsDataBinding;